export default "__VITE_ASSET__Dp5$1Y9J__"